import type { EditorState } from 'draft-js';
import type { FC } from 'types/react';

import { isStyleApplied } from '../../helpers/is-style-applied';
import { SubscriptIcon } from './static_assets';
import { Button } from './styles';

interface Props {
    editorState: EditorState;
    onClick: () => void;
}

export const SubscriptButton: FC<Props> = ({ editorState, onClick }) => (
    <Button $isActive={isStyleApplied('SUBSCRIPT', editorState)} onClick={onClick}>
        <SubscriptIcon />
    </Button>
);
